import { z } from 'zod';
import { categorySchema } from './enums.js';
// Itinerary contract (SPEC §1.3). A stop schedules a (located) list item on a
// day — the list item is the single source of location + linkage.
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');
const hhmm = z.string().regex(/^\d{2}:\d{2}$/, 'Expected HH:MM');
export const stopCreateSchema = z.object({
    date: isoDate,
    listItemId: z.string(),
    time: hhmm.nullable().optional(),
    note: z.string().max(1000).nullable().optional(),
});
export const stopUpdateSchema = z.object({
    time: hhmm.nullable().optional(),
    note: z.string().max(1000).nullable().optional(),
    order: z.number().int().optional(),
});
/** Reorder / move stops within (or into) a single day. */
export const stopReorderSchema = z.object({
    date: isoDate,
    orderedStopIds: z.array(z.string()),
});
export const itineraryStopSchema = z.object({
    id: z.string(),
    dayId: z.string(),
    date: isoDate,
    listItemId: z.string(),
    title: z.string(),
    category: categorySchema,
    lat: z.number().nullable(),
    lng: z.number().nullable(),
    time: z.string().nullable(),
    note: z.string().nullable(),
    order: z.number().int(),
});
export const itineraryDaySchema = z.object({
    date: isoDate,
    dayId: z.string().nullable(),
    stops: z.array(itineraryStopSchema),
});
//# sourceMappingURL=itinerary.js.map